import React from "react";

const MyPageAttendCard2 = ({ program, retailText}) => {
  return (
    <div style={styles.card}>
      {/* D-Day 표시 */}
      <div style={styles.cardLeft}>
        <div style={styles.info}>
          <div className="font-body2-semibold" style={styles.programName}>
            {program.name}
          </div>
        </div>
        <div className="font-body4-medium" style={styles.period}>
          {program.date && (
            (() => {
              const dateObj = new Date(program.date);
              return `${dateObj.getFullYear()}년 ${String(dateObj.getMonth() + 1).padStart(2, '0')}월 ${String(dateObj.getDate()).padStart(2, '0')}일`;
            })()
          )}
        </div>
      </div>
      {/* 메뉴 버튼 */}
      <p
        className="font-body4-medium"
        style={{ color: "var(--grayscale_70)" }}
      >
        {retailText} {program.ratio}%
      </p>
    </div>
  );
};

const styles = {
  card: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 20px 12px 20px",
    borderRadius: "4px",
    backgroundColor: "#fff",
    boxShadow: "0px 4px 8px 0px rgba(157, 163, 191, 0.10)",
    borderLeft: "3px solid var(--primary-crimson_30)",
  },
  cardLeft: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },  
  info: {
    display: "flex",
    gap: "8px",
  },
  programName: {
    color: "var(--grayscale_100)",
    display: "flex",
    alignItems: "center",
  },
  period: {
    color: "var(--grayscale_80)",
  },
}

export default MyPageAttendCard2;